import { resumenReparto, type Reparto, type VarianteDeSku } from '../lib/variantes';

/** Reparto opcional de lo recibido en una línea del remito entre las variantes del SKU; lo que no se reparta queda «Sin asignar». */
export function RepartoVariantes({ variantes, recibido, reparto, onChange }: {
  variantes: VarianteDeSku[]; recibido: number; reparto: Reparto; onChange: (r: Reparto) => void;
}) {
  const { repartidas, sinAsignar, excede } = resumenReparto(recibido, reparto);
  return (
    <div className="mt-2 rounded-lg bg-slate-50 p-2 text-xs space-y-2">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {variantes.map((v) => (
          <label key={v.id} className="flex items-center gap-1">
            <span aria-hidden className="inline-block w-3 h-3 rounded border border-slate-300" style={{ backgroundColor: v.colorHex ?? 'transparent' }} />
            <span className="truncate">{v.nombre}</span>
            <input type="number" min="0" step="any" aria-label={`Cantidad de ${v.nombre}`} value={reparto[v.id] ?? ''}
              onChange={(e) => onChange({ ...reparto, [v.id]: e.target.value })} className="w-16 px-1 py-1 border rounded text-xs" />
          </label>
        ))}
      </div>
      <progress max={recibido} value={repartidas} className="w-full h-2" />
      <p className={excede ? 'text-red-700' : 'text-slate-600'}>
        {`Repartidas ${repartidas} de ${recibido} · ${sinAsignar} quedan Sin asignar`}
      </p>
      {excede && <p role="alert" className="text-red-700">{`El reparto (${repartidas}) supera lo recibido (${recibido}).`}</p>}
    </div>
  );
}
